"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var presets;
            (function (presets) {
                class InitArgs {
                    constructor() {
                        this.dataNamesUsed = [];
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    setRowsOnPageLoad();
                }
                presets.init = init;
                function addEvents() {
                    $(document).on('click', '.fieldTable .delete_button', function () {
                        var _a, _b, _c, _d;
                        const presetIdx = (_d = (_c = (_b = (_a = $(this)) === null || _a === void 0 ? void 0 : _a.closest('.fieldTable')) === null || _b === void 0 ? void 0 : _b.attr('id')) === null || _c === void 0 ? void 0 : _c.replace('fields_', appn.emptyString)) !== null && _d !== void 0 ? _d : 0;
                        const dataname = $(this).data('name');
                        $(`#addField_${presetIdx} option[value='${dataname}']`).prop('disabled', false);
                        const parentName = $(this).parents('tr').attr('parent');
                        $(this).parents('tr').remove();
                        checkToRemoveParentRowIfEmpty(Number(presetIdx), parentName);
                        if ($(`#fields_${presetIdx} tbody tr`).length > 0)
                            reIndexRowItems(presetIdx);
                        else {
                            const span = appn.elementBuilder.createElement('span', ['lead', 'text-gray'], undefined, undefined, T('Select which fields can be edited when dispatching the Task'));
                            const div = appn.elementBuilder.createElement('div', 'text-center');
                            div.appendChild(span);
                            const cell = appn.elementBuilder.createElement('td', undefined, undefined, [['colspan', '4']]);
                            cell.appendChild(div);
                            const row = appn.elementBuilder.createElement('tr', 'helperText');
                            row.appendChild(cell);
                            $(`#fields_${presetIdx} tbody`).append(row);
                        }
                        appn.select.init();
                    });
                    $('.addField').on('change', function (event) {
                        event.preventDefault();
                        $('.helperText').remove();
                        if ($(this).val() === '0')
                            return;
                        const presetIdx = $(this).attr('id').replace('addField_', appn.emptyString);
                        const dataName = $(this).val();
                        const type = appn.elementBuilder.RowType[$(this).find('option:checked').attr('row-type')];
                        const newRow = appn.elementBuilder.getNewRow(this, dataName, false, presetIdx, type, _initArgs.dataNamesUsed);
                        $(`#fields_${presetIdx} tbody`).append(newRow);
                        $(`#addField_${presetIdx} option[value="${$(this).val()}"]`).prop('disabled', true);
                        $(`#addField_${presetIdx}`).val('0');
                        reIndexRowItems(Number(presetIdx));
                        appn.select.init();
                    });
                }
                function setRowsOnPageLoad() {
                    if (_initArgs.dataNamesUsed.length === 0)
                        return;
                    _initArgs.dataNamesUsed.forEach((preset) => {
                        var presetIdx = Number(preset[0].split('|')[2]);
                        var select = $(`select[id="addField_${presetIdx}"]`);
                        $(`#fields_${presetIdx} tbody tr`).remove();
                        preset.forEach((dataSet) => {
                            const dataName = dataSet.split('|')[0];
                            const dataValue = dataSet.split('|')[1].toBooleanExact();
                            const option = $(`option[value="${dataName}"]`);
                            $(`#fields_${presetIdx} tbody`).append(appn.elementBuilder.getNewRow(select[0], dataName, dataValue, presetIdx.toString(), appn.elementBuilder.RowType[option.attr('row-type')], _initArgs.dataNamesUsed));
                            $(`#addField_${presetIdx} option[value="${dataName}"]`).prop('disabled', true);
                        });
                        $(`#addField_${presetIdx}`).val('0');
                        reIndexRowItems(presetIdx);
                        appn.ui.checkboxForceOnChanged('.task-template-preset-required');
                    });
                }
                function reOrganiseRowsToMaintainIndexes(presetIdx) {
                    const rowDataIndexes = [];
                    $(`#fields_${presetIdx} tbody tr`).each(function (index, row) {
                        rowDataIndexes.push(Number($(row).attr('data-index')));
                    });
                    rowDataIndexes.sort((a, b) => a - b);
                    const newTbody = document.createElement('tbody');
                    rowDataIndexes.forEach(function (rowDataIndex) {
                        $(`#fields_${presetIdx} tbody tr[data-index="${rowDataIndex}"]`).appendTo(newTbody);
                    });
                    $(`#fields_${presetIdx} tbody`).remove();
                    $(`#fields_${presetIdx}`).append(newTbody);
                }
                function reIndexRowItems(presetIdx) {
                    reOrganiseRowsToMaintainIndexes(presetIdx);
                    let rowIdx = 0;
                    $(`#fields_${presetIdx} tbody tr`).each(function (index, row) {
                        if (this.className === 'preset-page-header')
                            return;
                        $(this).find('input').each(function (index, col) {
                            var _a, _b;
                            let inputName = $(this).attr('name');
                            let inputId = $(this).attr('id');
                            const label = $(this).closest('.appn-checkbox').find('label');
                            if ((inputName === null || inputName === void 0 ? void 0 : inputName.lastIndexOf('.Index')) !== -1)
                                $(this).attr('value', rowIdx);
                            inputName = (_a = inputName === null || inputName === void 0 ? void 0 : inputName.replace(/\.Fields\[[0-9]+\]\./, `.Fields[${rowIdx}].`)) !== null && _a !== void 0 ? _a : appn.emptyString;
                            $(this).attr('name', inputName);
                            if (inputId !== undefined) {
                                inputId = (_b = inputId === null || inputId === void 0 ? void 0 : inputId.replace(/__Fields_[0-9]+__/, `__Fields_${rowIdx}__`)) !== null && _b !== void 0 ? _b : appn.emptyString;
                                $(this).attr('id', inputId);
                                if (label !== undefined)
                                    label.attr('for', inputId);
                            }
                        });
                        rowIdx++;
                    });
                    appn.popover.init();
                }
                function checkToRemoveParentRowIfEmpty(presetIdx, parentName) {
                    const children = $(`#fields_${presetIdx} tbody tr[parent="${parentName}"]`);
                    if (children.length === 0) {
                        const grandParentName = $(`#fields_${presetIdx} tbody tr[id="${parentName}"]`).attr('parent');
                        $(`#fields_${presetIdx} tbody tr[id="${parentName}"]`).remove();
                        if (grandParentName)
                            checkToRemoveParentRowIfEmpty(presetIdx, grandParentName);
                    }
                }
            })(presets = taskTemplates.presets || (taskTemplates.presets = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
